(() => {
  const route = suffix => (window.Shopify?.routes?.root || '/') + suffix;
  const safeUrl = value => {
    const url = new URL(value, location.origin);
    return url.origin === location.origin ? url.href : null;
  };
  const make = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-fm-header]').forEach(header => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const menu = header.querySelector('[data-fm-menu]');
      const cart = header.querySelector('[data-fm-cart]');
      const search = header.querySelector('[data-fm-search]');
      const input = search.querySelector('[data-fm-search-input]');
      const results = search.querySelector('[data-fm-search-results]');
      const list = results.querySelector('[data-fm-search-list]');
      const status = results.querySelector('[data-fm-search-status]');
      let searchTimer, controller, returnFocus;
      const open = (dialog, trigger) => {
        returnFocus = trigger;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('fm-dialog-open');
      };
      [menu, cart].forEach(dialog => {
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('fm-dialog-open');
          returnFocus?.focus();
        });
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        });
      });
      header.querySelector('[data-fm-menu-open]').addEventListener('click', event => open(menu, event.currentTarget));
      header.querySelector('[data-fm-menu-close]').addEventListener('click', () => menu.close());
      header.querySelector('[data-fm-cart-close]').addEventListener('click', () => cart.close());
      header.querySelector('[data-fm-cart-open]').addEventListener('click', async event => {
        event.preventDefault();
        const target = event.currentTarget;
        const holder = cart.querySelector('[data-fm-cart-items]');
        holder.replaceChildren();
        cart.setAttribute('aria-busy', 'true');
        open(cart, target);
        try {
          const response = await fetch(route('cart?view=json'), {headers: {Accept: 'text/html'}});
          if (!response.ok) throw new Error('Cart request failed');
          holder.innerHTML = await response.text();
          const terms = holder.querySelector('#FamiilyDrawerTerms');
          if (terms) {
            terms.id = 'FamiilyHeaderDrawerTerms';
            holder.querySelector('label[for="FamiilyDrawerTerms"]').htmlFor = terms.id;
          }
        } catch { location.assign(cart.dataset.cartUrl); }
        finally { cart.removeAttribute('aria-busy'); }
      });
      const closeResults = () => { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };
      input.addEventListener('input', () => {
        clearTimeout(searchTimer); controller?.abort();
        const query = input.value.trim();
        if (query.length < 2) { closeResults(); return; }
        searchTimer = setTimeout(async () => {
          controller = new AbortController();
          const currentController = controller;
          try {
            const params = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '6'});
            const response = await fetch(route('search/suggest.json?') + params, {signal: currentController.signal});
            if (!response.ok) throw new Error('Search request failed');
            const data = await response.json();
            if (input.value.trim() !== query || !header.isConnected) return;
            const products = data.resources.results.products;
            list.replaceChildren();
            products.forEach(product => {
              const item = make('li'); const link = make('a');
              link.href = safeUrl(product.url) || route('search?q=') + encodeURIComponent(query);
              if (product.image) { const img = make('img'); img.src = product.image; img.width = 52; img.height = 52; img.alt = ''; link.append(img); }
              link.append(make('span', '', product.title.split('|')[0].trim())); item.append(link); list.append(item);
            });
            status.textContent = products.length ? results.dataset.resultLabel : results.dataset.emptyLabel;
            results.hidden = false; input.setAttribute('aria-expanded', 'true');
          } catch (error) { if (error.name !== 'AbortError') closeResults(); }
        }, 240);
      });
      search.addEventListener('keydown', event => {
        if (event.key === 'Escape') { closeResults(); input.focus(); }
        if (event.key === 'ArrowDown' && event.target === input && !results.hidden) { event.preventDefault(); list.querySelector('a')?.focus(); }
      });
      search.addEventListener('focusout', () => setTimeout(() => { if (!search.contains(document.activeElement)) closeResults(); }, 0));
      header.querySelectorAll('[data-fm-mega]').forEach(mega => {
        let closeTimer;
        mega.addEventListener('pointerenter', event => { clearTimeout(closeTimer); if (event.pointerType === 'mouse' && innerWidth >= 1024) mega.open = true; });
        mega.addEventListener('pointerleave', () => { closeTimer = setTimeout(() => { if (!mega.contains(document.activeElement)) mega.open = false; }, 160); });
        mega.addEventListener('keydown', event => { if (event.key === 'Escape') { mega.open = false; mega.querySelector('summary').focus(); } });
      });
    });
    root.querySelectorAll('[data-fm-price-preset]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const maximum = document.getElementById(button.dataset.fmPriceInput);
        const form = button.closest('form');
        if (!maximum || !form) return;
        maximum.value = button.dataset.fmPricePreset;
        const minimum = form.querySelector('input[name="filter.v.price.gte"]');
        if (minimum) minimum.value = '';
        form.requestSubmit();
      });
    });
    root.querySelectorAll('[data-fm-row-next],[data-fm-row-prev]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const row = button.closest('section').querySelector('[data-fm-scroll-row]');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        row?.scrollBy({left: row.clientWidth * (button.hasAttribute('data-fm-row-next') ? .8 : -.8), behavior: reduced ? 'instant' : 'smooth'});
      });
    });
    root.querySelectorAll('.famiily-card__media').forEach(card => {
      const image = card.querySelector('[data-fm-hover-src]');
      if (!image || card.dataset.ready) return;
      card.dataset.ready = 'true';
      card.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !image.dataset.fmHoverSrc) return;
        image.addEventListener('load', () => image.classList.add('fm-image-ready'), {once: true});
        image.src = image.dataset.fmHoverSrc;
        delete image.dataset.fmHoverSrc;
      });
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-fm-mega][open]').forEach(mega => { if (!mega.contains(event.target)) mega.open = false; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
